import {BsInstagram} from 'react-icons/bs'
import {FaFacebookSquare} from 'react-icons/fa'
export default function MobileContactHeader() {
  return (
    <div className="w-[100%] mt-5 flex flex-row justify-between align-middle items-center p-4 rounded-lg bg-[#F5F6FA]">
      <div className="flex flex-col align-middle justify-between">
        <div className="flex flex-row mb-4 ">
          <div className="flex justify-between align-middle items-center">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.97942 5.71991C5.59787 6.10188 5.24802 6.57042 5.02182 6.97841C4.73771 7.47707 4.52797 8.02389 4.40152 8.59241L4.33572 8.93592C3.29871 14.1972 4.6157 18.9038 8.96325 23.2204C11.8158 26.0526 13.9788 27.2164 16.9406 27.6413C17.4205 27.7102 17.9218 27.7619 18.5183 27.8061L19.7446 27.8806C20.429 27.916 21.5693 27.9728 21.9586 27.995C22.4713 28.0242 23.1496 27.9261 24.0612 27.7126L24.1993 27.6721C24.9951 27.391 25.7217 26.9349 26.3301 26.3258C28.5566 24.0969 28.5566 20.4831 26.3301 18.2542L26.1318 18.0648C23.9795 16.1049 20.6882 16.087 18.5158 18.0207L18.2582 18.2538L16.8817 19.6318C16.5801 19.9337 16.1051 19.9746 15.7564 19.7287C15.0309 19.217 13.1032 17.3304 12.6327 16.6874C12.3769 16.3378 12.414 15.8537 12.7201 15.5474L13.9329 14.3341L14.0366 14.2497L14.1906 14.107C14.2184 14.0802 14.2467 14.0524 14.2748 14.0244C16.5655 11.7311 16.5655 8.01312 14.2748 5.71991C11.9841 3.4267 8.27012 3.4267 5.97942 5.71991ZM7.84006 7.58259C9.10315 6.31811 11.151 6.31811 12.4141 7.58259C13.6772 8.84707 13.6772 10.8972 12.4141 12.1617C12.336 12.2399 12.2546 12.3136 12.1701 12.3827L10.86 13.6843C9.63541 14.9097 9.48685 16.846 10.51 18.2442C11.1504 19.1192 13.2835 21.2069 14.2409 21.8822L14.4256 22.004C15.7998 22.8498 17.5882 22.6499 18.7424 21.4944L20.0149 20.2201L20.0323 20.2113L20.1549 20.0913C21.3559 18.9159 23.2803 18.9263 24.4695 20.1169C25.6684 21.3171 25.6684 23.2629 24.4695 24.4631L24.265 24.6505C24.0536 24.8276 23.822 24.9735 23.5753 25.0863L23.3762 25.1664L23.0379 25.2409L22.6807 25.3078C22.412 25.3528 22.2173 25.3712 22.1082 25.365L19.4364 25.2262L18.7286 25.1802L18.1146 25.1285C17.8268 25.1007 17.5647 25.0697 17.3138 25.0337C14.9428 24.6936 13.2858 23.802 10.8162 21.35C7.2278 17.7872 6.11555 14.1017 6.84874 9.81688L6.92544 9.40033C6.99495 8.9737 7.12368 8.60608 7.3151 8.27002C7.43164 8.05999 7.63432 7.78856 7.84006 7.58259Z"
                fill="#00214D"
              />
            </svg>
          </div>
          <div className="flex flex-col justify-between align-middle mr-4">
            <p className="text-sm text-gray-400">الهاتف</p>
            <p className="text-md">046114630</p>
          </div>
        </div>
        <div className="flex flex-row mb-4 ">
          <div className="flex justify-between align-middle items-center">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.66797 5.33203C4.45883 5.33203 2.66797 7.12289 2.66797 9.33203V22.6654C2.66797 24.8745 4.45883 26.6654 6.66797 26.6654H25.3346C27.5438 26.6654 29.3346 24.8745 29.3346 22.6654V9.33203C29.3346 7.12289 27.5438 5.33203 25.3346 5.33203H6.66797ZM6.43532 8.01892C6.51087 8.00563 6.58861 7.9987 6.66797 7.9987H25.3346C25.414 7.9987 25.4918 8.00563 25.5673 8.01893L16.0013 14.3963L6.43532 8.01892ZM5.33464 10.4901V22.6654C5.33464 23.4017 5.93159 23.9987 6.66797 23.9987H25.3346C26.071 23.9987 26.668 23.4017 26.668 22.6654V10.4901L16.7409 17.1081C16.2931 17.4067 15.7096 17.4067 15.2617 17.1081L5.33464 10.4901Z"
                fill="#00214D"
              />
            </svg>
          </div>
          <div className="flex flex-col justify-between align-middle mr-4">
            <p className="text-sm text-gray-400">البريد الإلكتروني</p>
            <p className="text-md">info@basmti.com</p>
          </div>
        </div>
        <div className="flex flex-row mb-4 ">
          <div className="flex justify-between align-middle items-center">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.0013 5.33464C12.3194 5.33464 9.33464 8.3194 9.33464 12.0013C9.33464 15.7185 11.4836 21.1577 16.0013 26.075C20.519 21.1577 22.668 15.7185 22.668 12.0013C22.668 8.3194 19.6832 5.33464 16.0013 5.33464ZM6.66797 12.0013C6.66797 6.84664 10.8466 2.66797 16.0013 2.66797C21.156 2.66797 25.3346 6.84664 25.3346 12.0013C25.3346 16.8709 22.4487 23.4395 16.9441 28.9441C16.4234 29.4648 15.5792 29.4648 15.0585 28.9441C9.5539 23.4395 6.66797 16.8709 6.66797 12.0013Z"
                fill="#00214D"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.0013 13.3346C16.7377 13.3346 17.3346 12.7377 17.3346 12.0013C17.3346 11.2649 16.7377 10.668 16.0013 10.668C15.2649 10.668 14.668 11.2649 14.668 12.0013C14.668 12.7377 15.2649 13.3346 16.0013 13.3346ZM16.0013 16.0013C18.2104 16.0013 20.0013 14.2104 20.0013 12.0013C20.0013 9.79216 18.2104 8.0013 16.0013 8.0013C13.7922 8.0013 12.0013 9.79216 12.0013 12.0013C12.0013 14.2104 13.7922 16.0013 16.0013 16.0013Z"
                fill="#00214D"
              />
            </svg>
          </div>
          <div className="flex flex-col justify-between align-middle mr-4">
            <p className="text-sm text-gray-400">العنوان</p>
            <p className="text-md">المنطقة الصناعية، تعناخيم، جلبواع</p>
          </div>
        </div>
        <div className="flex flex-row mt-3">
          <FaFacebookSquare className="w-[25px] h-[25px] ml-4" />
          <BsInstagram className="w-[25px] h-[25px]" />
        </div>
      </div>
    </div>
  )
}
